<div #viewer [ngClass]="isStack || isGrayscale ? 'file-viewer with-menu-height p-0 m-0 border-none'
  : 'file-viewer default-height p-0 m-0 border-none'">
  <ng-container [ngSwitch]="true">
    <div *ngSwitchCase="displayType === DisplayType.None" >
      <div id="cover">
        <!-- margin/padding to horizontally align the panel to the menu tabs on its sides -->
        <div id="image-files-security-container">
          <p-panel styleClass="border-noround" id="image-files-security-panel"
                   header="Data Security on JAX Image Tools"
                   [toggleable]="true" expandIcon="pi pi-fw pi-chevron-up"
                   collapseIcon="pi pi-fw pi-chevron-down">
            <!-- [NOTE: GIK 07/10/2023] - commented out due to stakeholder discussion -->
            <!--
            <pdf-viewer
              id="users-guide-manual"
              [src]="srcUsersGuidePdf"
              [render-text]="true"
              [original-size]="false"
              [show-all]="true"
              [zoom]="0.9"
              [zoom-scale]="'page-width'"
              [autoresize]="true"
              [show-borders]="false"
              class="h-30rem"
            ></pdf-viewer>
            <p class="text-justify font-medium line-height-3">
              <a
                href="https://jacksonlaboratory.sharepoint.com/:p:/r/sites/Microscopy/_layouts/15/Doc.aspx?sourcedoc=%7BE44F9388-729C-47B6-ACC2-196F89D71495%7D&file=How-to-use-JAX-image-tools.pptx&action=edit&mobileredirect=true"
                target="_blank"
              >Click here</a> to view the User's Guide document in full resolution.
            </p>
            -->
            <p class="text-justify font-medium line-height-3">
              In JAX Image Tools, images are not available to the
              general public - only users with valid SSO credentials can sign in
              and use the application.
            </p>
          </p-panel>
        </div>

        <!-- cloud buckets panel -->
        <div id="cloud-buckets-panel-container" class="my-4">
          <p-panel id="cloud-buckets-panel" styleClass="border-noround"
                   header="Cloud Buckets" [toggleable]="true" [collapsed]="true"
                   expandIcon="pi pi-fw pi-chevron-up"
                   collapseIcon="pi pi-fw pi-chevron-down">
            <p class="text-justify font-medium line-height-3">
              Data on the
              <a
                href="https://jacksonlaboratory.sharepoint.com/sites/Microscopy/SitePages/Cloud-Image-Tools.aspx"
                target="_blank"
              >JAX Image Tools</a> are stored in containers called
              <a href="https://cloud.google.com/storage/docs/buckets"
                 target="_blank"
              >buckets</a> in Google Cloud Storage.
              All buckets are associated with a
              <a
                href="https://cloud.google.com/storage/docs/projects"
                target="_blank"
              >project</a>, and the projects are associated with an
              <a
                href="https://cloud.google.com/resource-manager/docs/cloud-platform-resource-hierarchy#organizations"
                target="_blank"
              >organization</a>.
            </p>

            <p class="text-justify font-medium line-height-2">
              Research labs and services can request a storage bucket within JAX-Cloud
              Image Tools project to store and analyze their data. Upload and download
              of data to and from the buckets is done via
              <a
                href="https://jacksonlaboratory.sharepoint.com/:p:/r/sites/Microscopy/_layouts/15/Doc.aspx?sourcedoc=%7BDE19B63A-9F37-483C-AF92-B606132A2BF3%7D&file=gsutil.pptx&action=edit&mobileredirect=true"
                target="_blank"
              >gsutil tool</a>. You can grant permission to make your
              data accessible to principals you specify and organize the file
              structure within the buckets according to your preference.
            </p>
          </p-panel>
        </div>

        <!-- file structure panel -->
        <div id="file-structure-panel-container" class="my-4">
          <p-panel id="file-structure" header="File Structure" styleClass="border-noround"
                   [toggleable]="true" [collapsed]="true"
                   expandIcon="pi pi-fw pi-chevron-up"
                   collapseIcon="pi pi-fw pi-chevron-down">
            <p class="text-justify font-medium line-height-3">
              There are essentially two different folder types: user-created and
              workflow generated. User can create their own file structure to organize
              data by creating folders and nested folders within their storage bucket.
              Workflow-generated folders appear in the parent folder and contain the
              results created by the execution of the workflow. Each workflow creates
              its own resulting files, for details please see below.
            </p>

            <h3>&bull; Slide Cropper</h3>
            <p class="text-justify font-medium line-height-3">
              Executing the 'Slide Cropper' workflow creates the output
              folder named after the parent image within the parent folder.
              The output folder will contain an overview image in JPEG format
              with the Region of Interests (ROIs) marked, cropped ROIs in TIFF
              or TIFF GZ format, preview images of the ROIs in PNG format, and JSON files.
            </p>

            <h3>&bull; Fibers and Nuclei</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the “Fibers and Nuclei” workflow selected,
              the user specifies the name of the output folder. After the successful
              completion of the workflow, the results appear inside the
              user-specified output folder within the parent folder.
              This workflow creates two CSV files - fiber_area.csv and nuclei_area.csv -
              and a folder that contains an XML metadata file, proof.tiffs,
              and JSON files for each ROI processed.
              <br/><br/>
              <b>Batch mode</b>: If you choose to output the
              results from multiple images into the same output folder,
              the two CSV files will get appended with the metrics of all
              fibers and nuclei identified from each of those processed
              images along with separate folders containing XML metadata file,
              proof.tiffs, and JSON files.
            </p>

            <h3>&bull; Image Alignment</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Image Alignment' workflow selected, the
              user can specify the output folder and the output file names within
              the parent folder. This workflow creates two images in TIFF file format,
              a transformed image and an overlayed image.
            </p>

            <h3>&bull; Extended Depth of Field:</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Extended Depth of Field' workflow selected,
              the user can specify the output folder and the output file name within the
              parent folder. This workflow creates a resultant image in TIFF file format.
            </p>

            <h3>&bull; Kidney Classifier:</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Kidney Classifier' workflow selected,
              the user can analyze kidney histology, generating heatmaps for damage assessment,
              and the tool will provide detailed CSV reports at pixel, slide, and section levels,
              along with tissue masks.
            </p>

            <h3>&bull; Yolo Segdetect:</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Yolo Segdetect' workflow selected,
              the user can run AI-powered object detection and segmentation on
              histology and microscopy images. The tool uses YOLO-based deep learning
              models to detect and segment structures such as optic nerves, retinal
              layers, and embryos, producing annotated images with bounding boxes and
              segmentation masks, along with quantification reports in CSV format.
            </p>

            <h3>&bull; Retinal Layer Segmentation:</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Retinal Layer Segmentation' workflow selected,
              the user can perform automated segmentation of retinal tissue layers from
              OCT or histology images. The tool identifies and delineates individual
              retinal layers, producing segmented overlay images and thickness
              measurements exported as CSV reports.
            </p>

            <h3>&bull; Stain Adaptation:</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Stain Adaptation' workflow selected,
              the user can normalize staining variations across histology images.
              The tool adapts the color profile of a source image to match a target
              staining style, enabling consistent visual comparison and downstream
              analysis across slides stained under different conditions.
            </p>

            <h3>&bull; Color Deconvolution:</h3>
            <p class="text-justify font-medium line-height-3">
              In the 'Process' tab with the 'Color Deconvolution' workflow selected,
              the user can separate a multi-stained histology image into its individual
              stain channels. The tool decomposes the color information to isolate each
              stain component (e.g., Hematoxylin and Eosin), producing separate
              single-channel images for independent analysis and quantification.
            </p>
          </p-panel>
        </div> <!-- END File Structure Panel -->

        <!-- release notes panel — content is rendered from CHANGELOG.md
             (single source of truth, see FileViewerComponent.loadReleaseNotes). -->
        <div id="release-notes-panel-container" class="my-4">
          <p-panel id="release-notes" header="Release Notes" styleClass="border-noround"
                   [toggleable]="true" [collapsed]="true"
                   expandIcon="pi pi-fw pi-chevron-up"
                   collapseIcon="pi pi-fw pi-chevron-down">
            <div *ngIf="releaseNotesError; else releaseNotesContent" class="text-color-secondary">
              {{ releaseNotesError }}
            </div>
            <ng-template #releaseNotesContent>
              <div class="release-notes-markdown" [innerHTML]="releaseNotesHtml"></div>
            </ng-template>
          </p-panel>
        </div> <!-- END Release notes -->
      </div>
    </div>

    <!--
      NB: draw2d canvas requires 'h-full' class to correctly function;

      renders draw2d canvas containing an image
    -->
    <!-- One case for an image, a spatial-omics dataset and annotations opened by themselves, so
         moving between them keeps the same visualizer rather than tearing it down. -->
    <div *ngSwitchCase="showsVisualizer"
         class="h-full">
      <diagram id="diagram" (isStackEvent)="setIsStack($event)"
               (isGrayscaleEvent)="setIsGrayscale($event)"></diagram>
    </div>

    <!-- renders JSON content -->
    <div *ngSwitchCase="displayType === DisplayType.Code" class="h-full mt-6 pt-2">
      <code-panel></code-panel>
    </div>

    <!-- renders results summary -->
    <div *ngSwitchCase="displayType === DisplayType.ResultsSummary" class="h-full mt-6 pt-2">
      <results-summary></results-summary>
    </div>

    <!-- renders tabulated data -->
    <div *ngSwitchCase="displayType === DisplayType.TabDelimited" class="h-full mt-6 pt-2">
      <dynamic-table></dynamic-table>
    </div>
  </ng-container>
</div>
